function AbortionError() {
	Error.call(this);

	if (Error.captureStackTrace) {
		Error.captureStackTrace(this, arguments.callee);
	}

	this.name = 'AbortionError';
}

AbortionError.prototype = Object.create(Error.prototype);

module.exports = AbortionError;
